module.exports = __webpack_public_path__ + "static/media/ios-business.c04e5b35.svg";